exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-7179bdc4]:not(.disabled){\n  cursor: pointer;\n}\na.disabled[data-v-7179bdc4]{\n  cursor: default;\n  pointer-events: none;\n}\n", ""]);

// exports
